export default "__VITE_ASSET__de6320c6__"